import { render, staticRenderFns } from "./ReportCollection.vue?vue&type=template&id=6d1b1b9a&scoped=true&"
import script from "./ReportCollection.vue?vue&type=script&lang=js&"
export * from "./ReportCollection.vue?vue&type=script&lang=js&"
import style0 from "./ReportCollection.vue?vue&type=style&index=0&id=6d1b1b9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1b1b9a",
  null
  
)

export default component.exports